import { AnyAction } from 'redux';
import cloneDeep from 'lodash/cloneDeep';
import {
  GlobalActions,
  ProduktDeleted,
  TreuebonusChanged,
  VereinbarungenChanged,
  VertragslaufzeitChanged,
  Treuebonus,
} from '@ps20-frontend/shop-integration-redux';
import { ToolbarActions } from '../toolbar.actions';

export const treuebonusReducer = function (
  sectionState: Array<Treuebonus> = null,
  action: AnyAction,
): Array<Treuebonus> {
  switch (action.type) {
    case ToolbarActions.TREUEBONUS_MAX_UPDATED: {
      return action.payload;
    }
    case ToolbarActions.TREUEBONUS_CHANGED_TEMP: {
      const actionPayload: TreuebonusChanged = action.payload;
      let newState: Array<Treuebonus> = cloneDeep(sectionState);
      if (actionPayload.treuebonus != null && actionPayload.appId != null) {
        newState = newState.map(elem => {
          if (elem.appId === actionPayload.appId && elem.angebotsId === actionPayload.angebotsId) {
            elem.treuebonus_changed = actionPayload.treuebonus;
          }
          return elem;
        });
      } else {
        newState = newState.map(elem => {
          elem.treuebonus_changed = elem.treuebonus_aktuell;
          return elem;
        });
      }
      return newState;
    }
    case GlobalActions.VEREINBARUNGEN_CHANGED: {
      let newState: Array<Treuebonus> = cloneDeep(sectionState);
      const actionPayload: VereinbarungenChanged = action.payload;
      newState = newState.map(treuebonus => {
        const actionPayloadTreuebonus = actionPayload.tbChanges.find(
          payloadTreuebonus =>
            payloadTreuebonus.appId === treuebonus.appId &&
            treuebonus.angebotsId === payloadTreuebonus.angebotsId,
        );
        if (actionPayloadTreuebonus) {
          treuebonus.treuebonus_aktuell = actionPayloadTreuebonus.treuebonus;
        }
        return treuebonus;
      });
      return newState;
    }
    case GlobalActions.PRODUKT_DELETED: {
      let newState: Array<Treuebonus> = cloneDeep(sectionState);
      const actionPayload: ProduktDeleted = action.payload;

      newState = newState.filter(elem => {
        return !actionPayload.angebotsIds.some(
          angebotsId =>
            angebotsId.appId === elem.appId && angebotsId.angebotsId === elem.angebotsId,
        );
      });

      return newState;
    }
    case GlobalActions.VERTRAGSLAUFZEIT_CHANGED: {
      const changedLaufzeitEvent: VertragslaufzeitChanged = action.payload;
      let newState: Array<Treuebonus> = cloneDeep(sectionState);
      newState = newState.map(treuebonus => {
        if (
          treuebonus.appId === changedLaufzeitEvent.appId &&
          treuebonus.angebotsId === changedLaufzeitEvent.angebotsId
        ) {
          treuebonus.laufzeit = changedLaufzeitEvent.vertragslaufzeit;
          if (treuebonus.laufzeit === 1 && treuebonus.treuebonus_aktuell > 0) {
            treuebonus.treuebonus_aktuell = 0;
          }
        }
        return treuebonus;
      });
      return newState;
    }
    case GlobalActions.UPDATE_ASSEKURANZTARIF_DATA: {
      if (action.payload) {
        return sectionState.map(tb => ({ ...tb, treuebonus_aktuell: 0 }));
      }
      return sectionState;
    }
    default:
      return sectionState;
  }
};
